import
    React
    , {
          useRef
        , useState
        , useCallback
        , useEffect
    } from "react";

import {
      useNavigate
    , useLocation
    //, useParams
    , Link
} from 'react-router-dom';

import {
      useDispatch
    , useSelector
} from 'react-redux';

//import { persistStore }                 from 'redux-persist';
//import store                            from "./redux/store";
import { referralCodeUpdate }           from "../../redux/keySlice";

import {
    details
    , increment
    //, setEuroValue
} from '../../redux/counterSlice';

import { MetaKeep } from 'metakeep';

import {
    axiosInstance
    //, axiosInstanceBlockChain
} from "../../utils/API";

import styles from "../../styles/app.sass";

import ModalDialogWrapper from "../../screens/ModalDialogWrapper";
import Register from "../Register";

//import ResetPassword                    from "../../components/ResetPassword";
//import TermsAndConditions               from "../../screens/TermsAndConditions"
//import PrivacyPolicy                    from "../../screens/PrivacyPolicy"
//import ShippingPolicy                   from "../../screens/ShippingPolicy/ShippingPolicy";
//import ReturnsPolicy                    from "../../screens/ReturnsPolicy/ReturnsPolicy";
import Modal                            from "../../components/Modal";
import Icon from "../../components/Icon";

import {
    CircularProgress
    //, Drawer
    //, Divider
    //, IconButton
    //, TextField
} from "@mui/material";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { NAMES_CONSTANTS } from '../../constants';

import Swal from "sweetalert2";  // SweetAlert for modal dialogs

// Web3 Wallet Connect
import Web3Modal from "web3modal";
import Web3 from "web3";
//import WalletConnectProvider from "@walletconnect/web3-provider";
import { decryptData } from "../../utils/decrypt";

import {
      base_url
    , PopUpAlert
    , PopUpWarning
    , PopUpWarningThen
    , PopUpConfirmation
} from "../../controller/utils";

//import LoginModal from "../../components/Header/LoginModal";

//function RegisterModalDialog() {
const RegisterModalDialog = props => {
    console.debug('components/ModelDialogs/RegisterModalDialog()');
    
    console.debug("RegisterModalDialog: process.env.NODE_ENV = ", process.env.NODE_ENV);

    const navigate = useNavigate(); // Error: useNavigate() may be used only in the context of a <Router> component.
    const isAgreeTermsRef = useRef(null);
    const [isAgreeTerms, setIsAgreeTerms] = useState(false);
    const userAccessToken = useRef(null);
    const emailRef = useRef(null);
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    const repasswordRef = useRef(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    //const registerPasswordRef = useRef(null);
    const repeatPasswordRef = useRef(null);

    //const [registerError, setRegisterError] = useState({})
    const [registerObject, setRegisterObject] = useState({})
    const [registerPasswordVisibility, setRegisterPasswordVisibility] = useState(false);

    const handleChangeRegisterPasswordVisibility = () => {
        setRegisterPasswordVisibility(!registerPasswordVisibility);
    };

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [ isVisibleRegisterDialog, setIsVisibleRegisterDialog ] = useState(false);
    const [ isSecondaryModalDialogShowing, setIsSecondaryModalDialogShowing ] = useState(false);

    useEffect(() => {
        console.debug('RegisterModalDialog: useEffect(async() => {...')

        console.debug('    window.location.search = ', window.location.search)
        const queryParameters = new URLSearchParams(window.location.search)
        const referralCode = queryParameters.get('referral-code')
        console.debug('    referralCode = ', referralCode);
        if (referralCode) dispatch(referralCodeUpdate(referralCode));

    //};
    //}, 60000 * 25);
    }, []);

    const referralCode = useSelector((state)=> state?.keyVal?.referralCode);
    console.debug('RegisterModalDialog: referralCode = ', referralCode);



    const handleChangeAgreeTerms = (e) => {
        console.debug('handleChangeAgreeTerms('+e+')');

        console.debug('e.target.name = ', e.target.name);
        console.debug('e.target.value = ', e.target.value);
        console.debug('e.target.checked = ', e.target.checked);

        //setUserDetails({ ...userDetails, [e.target.name]: e.target.value })
        //setError({ ...error, [e.target.name]: '' })
        //handleUserDetailsChangeNameValue(e.target.name, e.target.value);
        //setIsAgreeTerms(e.target.value);
        //setIsAgreeTerms(e.target.checked);
        //setError({ ...error, [e.target.name]: '' })

        //registerError['agree_terms'] = 'Please Agree to the terms and conditions.';
        if (e.target.checked) {
            //props.setRegisterError({ ...registerError, [e.target.name]: '' });
            props.setRegisterError({ ...props.registerError, [e.target.name]: '' });
            setIsAgreeTerms(true);
        } else {
            //registerError['agree_terms'] = 'Please Agree to the terms and conditions.';
            //props.setRegisterError({ ...registerError, [e.target.name]: 'Please agree to the terms and conditions.' });
            props.setRegisterError({ ...props.registerError, [e.target.name]: 'Please agree to the terms and conditions.' });
            setIsAgreeTerms(false);
            //setRegisterError(registerError);
        }
    };

    return (

        <>

            <Modal
                visible = { props.isVisibleRegisterDialog }
                
                onClose = { props.handleCloseRegisterDialog }
                //onOutsideClick = { onOutsideClickLoginDialog }
                showCloseButton = { false }
                >

                <Register
                    //visible = { isVisibleLoginDialog }
                    isVisibleRegisterDialog = { props.isVisibleRegisterDialog }
                    //onClose = { handleCloseLoginDialog }
                    handleCloseRegisterDialog = { props.handleCloseRegisterDialog }
                    //onOutsideClick = { onOutsideClickLoginDialog }
                    isModal = { true }
                    showCloseButton = { true }
                    keyDownUsername = { props.keyDownUsername }
                    keyDownPassword = { props.keyDownPassword }
                    showLoginDialog = { props.showLoginDialog }
                    registerUser = { props.registerUser }
                    registerUser2 = { props.registerUser2 }
                    registerPasswordRef = { props.registerPasswordRef }
                    registerFormRef = { props.registerFormRef }
                    registerError = { props.registerError }
                    setRegisterError = { props.setRegisterError }
                    />

            </Modal>

        </>
    );
}

export default RegisterModalDialog;
